import React, { useState } from "react"
import { Modal } from "src/app/admin/_components/modal"
import { BorderedButton } from "src/components/Button"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import * as styles from "./MovingApplications.css"
import { MdClose } from "react-icons/md"
import { useSWRConfig } from "swr"
import { color } from "@smoothincorg/smooth-ui"

interface ReexamModalProps {
  open: boolean
  onClose: () => void
  movingApplicationId: number | string | undefined
}

export const ReexamModal: React.FC<ReexamModalProps> = ({ open, onClose, movingApplicationId }) => {
  const { postWithToken } = useSmoothApi()
  const [selectedResult, setSelectedResult] = useState<"要確認" | "空欄">("要確認")
  const { mutate } = useSWRConfig()

  if (!open) return null

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await postWithToken(
      `${SMOOTH_SMOOTHER_API_URL}/moving_applications/${movingApplicationId}/duplicate_main_examination`,
      {
        mainExaminationScoreResult: selectedResult,
      }
    )
    window.alert("再審査準備が完了しました")
    mutate(
      `${SMOOTH_SMOOTHER_API_URL}/moving_applications/${movingApplicationId}/main_examinations`
    )
    onClose()
  }

  return (
    <Modal onClose={onClose}>
      <div
        className="mx-auto mt-10 max-w-md rounded-sm bg-white p-6 shadow-sm"
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          minWidth: 600,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            background: "transparent",
            border: "none",
            fontSize: 24,
            cursor: "pointer",
            zIndex: 10,
            padding: 0,
            lineHeight: 1,
          }}
          aria-label="閉じる"
        >
          <MdClose />
        </button>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <h1 className="my-4 text-4xl font-bold">再審査準備</h1>
          <form onSubmit={handleSubmit}>
            <h2 className="my-4 text-2xl font-bold">
              本審査結果（`MainExaminationScore`）のResult
            </h2>
            <div
              style={{
                marginBottom: 16,
                marginTop: 16,
                height: 60,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {["要確認", "空欄"].map((val) => (
                <label
                  key={val}
                  style={{ marginRight: 16 }}
                  className={selectedResult === val ? styles.selectedLabel : styles.unselectedLabel}
                >
                  <input
                    type="radio"
                    name="resultRadio"
                    value={val}
                    checked={selectedResult === val}
                    onChange={() => setSelectedResult(val as "要確認" | "空欄")}
                  />
                  {val}
                </label>
              ))}
            </div>
            <p style={{ marginTop: 16, marginBottom: 16, color: "#ff0000" }}>
              {selectedResult === "要確認" &&
                "・審査一覧ページには表示されず、ヒアリング待ち状態となります"}
              {selectedResult === "空欄" &&
                "・審査一覧ページに表示され、審査プロセスが実行可能になります"}
            </p>
            <BorderedButton
              type="submit"
              style={{
                margin: "20px 0",
                width: "240px",
                height: 50,
                fontSize: 16,
                fontWeight: "bold",
                padding: "1rem",
                backgroundColor: color.main,
                color: "#fff",
              }}
            >
              再審査準備する
            </BorderedButton>
          </form>
        </div>
      </div>
    </Modal>
  )
}
